module.exports = __webpack_public_path__ + "8a5312775e1eea83b0a0e93d36e57006.mtl";